import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { TenantProvider } from './context/TenantContext';

// Route Components
import { ProtectedRoute, AdminRoute, ManagerRoute } from './components/routes';

// Public Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import CarDetails from './pages/CarDetails';
import Payment from './pages/Payment';
import Success from './pages/Success';
import BookingHistory from './pages/BookingHistory';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundCancellationPolicy from './pages/RefundCancellationPolicy';

// Admin Pages
import { 
  AdminDashboard, 
  CompanyList, 
  CompanyOnboard, 
  ManagerList, 
  ManagerAdd,
  AdminCarList,
  AdminCarAdd,
  AdminBookingList
} from './pages/admin';
import DocumentVerifications from './pages/admin/DocumentVerifications';

// Manager Pages
import { 
  ManagerDashboard, 
  CarList as ManagerCarList,
  CarAdd
} from './pages/manager';
import ManagerBookingList from './pages/manager/BookingList';
import CompanySettings from './pages/manager/CompanySettings';

function App() {
  return (
    <Router>
      <AuthProvider>
        <TenantProvider>
      <Routes>
            {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/car/:id" element={<CarDetails />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund-cancellation" element={<RefundCancellationPolicy />} />
            
            {/* Protected Routes (User) */}
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/bookings" element={<ProtectedRoute><BookingHistory /></ProtectedRoute>} />
            <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
            <Route path="/success" element={<ProtectedRoute><Success /></ProtectedRoute>} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
            <Route path="/admin/companies" element={<AdminRoute><CompanyList /></AdminRoute>} />
            <Route path="/admin/companies/new" element={<AdminRoute><CompanyOnboard /></AdminRoute>} />
            <Route path="/admin/companies/:id" element={<AdminRoute><CompanyOnboard /></AdminRoute>} />
            <Route path="/admin/managers" element={<AdminRoute><ManagerList /></AdminRoute>} />
            <Route path="/admin/managers/new" element={<AdminRoute><ManagerAdd /></AdminRoute>} />
            <Route path="/admin/cars" element={<AdminRoute><AdminCarList /></AdminRoute>} />
            <Route path="/admin/cars/new" element={<AdminRoute><AdminCarAdd /></AdminRoute>} />
            <Route path="/admin/cars/:id/edit" element={<AdminRoute><AdminCarAdd /></AdminRoute>} />
            <Route path="/admin/bookings" element={<AdminRoute><AdminBookingList /></AdminRoute>} />
            <Route path="/admin/verifications" element={<AdminRoute><DocumentVerifications /></AdminRoute>} />
            <Route path="/admin/settings" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
            
            {/* Manager Routes */}
            <Route path="/manager" element={<ManagerRoute><ManagerDashboard /></ManagerRoute>} />
            <Route path="/manager/cars" element={<ManagerRoute><ManagerCarList /></ManagerRoute>} />
            <Route path="/manager/cars/new" element={<ManagerRoute><CarAdd /></ManagerRoute>} />
            <Route path="/manager/cars/:id" element={<ManagerRoute><CarAdd /></ManagerRoute>} />
            <Route path="/manager/bookings" element={<ManagerRoute><ManagerBookingList /></ManagerRoute>} />
            <Route path="/manager/settings" element={<ManagerRoute><CompanySettings /></ManagerRoute>} />
            
            {/* 404 - Catch all */}
            <Route path="*" element={<NotFound />} />
      </Routes>
        </TenantProvider>
      </AuthProvider>
    </Router>
  );
}

// Simple 404 component
const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Page not found</p>
      <a 
        href="/" 
        className="px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
      >
        Go Home
      </a>
    </div>
  </div>
);

export default App;
